
import Layout from './Layout.vue'
import { computed, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import ChainTag from '@/components/ChainTag.vue'
import { getChainId } from '@/composables/metamask'
import config from '@/config'
import hexRgb from 'hex-rgb'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'Home',
  components: {
    // HelloWorld
    // ReCaptcha,
    Layout,
    ChainTag
  },
  setup () {
    const store = useStore()

    const chainId = computed(() => store.state.wallet.chainId)

    const { push } = useRouter()

    const toMyRecords = () => {
      push({
        name: 'MyRecords'
      })
    }

    function routeSendGift () {
      push({
        name: 'CreateRedPack'
      })
    }

    const bgColor = hexRgb(config.themeColor[config.skinImage].color, { alpha: 0.32, format: 'css' })

    return {
      chainId,
      routeSendGift,
      toMyRecords,
      bgColor
    }
  }
})
